// src/components/RequireModule.jsx
// P4-7 (D-319): route gate for a module that is switched per company. A hidden
// menu item is not security - without this the page still opens by URL.
// Renders nothing while the company loads, so a company with the module ON is
// not thrown to Home on a refresh. Goes inside the route's role block, never
// instead of it.

import { Navigate } from "react-router-dom";
import { useCompany } from "../context/CompanyContext";
import { isModuleOn } from "../utils/modules";

export default function RequireModule({ name, children }) {
  const { company, loading } = useCompany();

  if (loading) return null;
  return isModuleOn(company?.modules, name) ? children : <Navigate to="/" replace />;
}
